import extend from 'extend'

const options = {
  fmt: {
    // 日期格式化
    date: {
      format: 'yyyy-MM-dd hh:mm:ss'
    },
    // 货币格式化
    currency: {
      places: 2,
      symbol: '￥',
      thousand: ', ',
      decimal: '.'
    }
  },
  // hmac 认证
  authMac: {
    requestContentSymbol: '\n',
    authMacSymbol: 'MAC',
    nonceLen: 8
  }
}

export const merge = (opts = {}) => {
  extend(true, options, opts)
  console.log(options)
}

export default options



// WEBPACK FOOTER //
// ./src/packages/utils/options.js